import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

import Container from './Container';

const verColTopSm = '3em';
const verColTopMd = '4em';
const verColTopLg = '5em';

const VerContainer = Styled(Container)`
  padding-top: ${verColTopSm};

  ${media.medium`
    padding-top: ${verColTopMd};
  `}

  ${media.large`
    padding-top: ${verColTopLg};
  `}
`;

VerContainer.displayName = 'VerContainer';

export const InnerContainer = Styled(Container)`
  margin: 0 auto;
  padding: 0 1em;
  display: block;
  position: relative;
  max-width: 66.25em; /* 1060px */
`;

InnerContainer.displayName = 'InnerContainer';

export default VerContainer;
